import React, { Component, Fragment } from "react";
import HotModIndicator from "../common/HotModIndicator";

class PODTable extends Component {
  state = {
    isCancelled: false
  };
  constructor(props) {
    super(props);
    this.tableHeader = [
      "Cancel",
      "Part Number",
      "Item",
      "Description",
      "Lead Time Exempt",
      "Available Inventory",
      "Ordered Qty",
      "Received Qty",
      "PO Category",
      "Cost"
    ];
    this.categories = {
      R: "R-REG",
      P: "P-PLN",
      Q: "Q-QAD",
      S: "S-SEA",
      Z: "Z-RDZ",
      O: "O-OFS",
      M: "M-MEG",
      H: "H-HOL",
      F: "F-FOG",
      D: "D-DNR",
      B: "B-FWD",
      A: "A-ADV"
    };
    this.tableHeaderRef = React.createRef();
    this.tableRef = React.createRef();
  }

  formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  renderTableHeader = () => {
    return this.tableHeader.map(title => {
      return (
        <div
          key={title}
          className="table-cell"
          // eslint-disable-next-line
          style={title == "Description" ? { flex: "2" } : { flex: "1" }}
        >
          <h4 className="table-title table-text">{title}</h4>
        </div>
      );
    });
  };
  numberToCeroPadded = num => {
    var zeros = 9 - (num + "").length;
    for (let i = 0; i < zeros; i++) {
      num = "0" + num;
    }
    return num;
  };
  renderCategories = () => {
    return Object.keys(this.categories).map(cat => {
      return (
        <option key={this.categories[cat]} value={cat}>
          {this.categories[cat]}
        </option>
      );
    });
  };
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  onKeyPress = e => {
    if (e.key === "ArrowUp" || e.key === "ArrowRight") {
      this.handleChangeQtyOrdered(e, 1);
    }
    if (e.key === "ArrowDown" || e.key === "ArrowLeft") {
      this.handleChangeQtyOrdered(e, -1);
    }
  };
  changeQty = (e, ref, row) => {
    var filteredQuery = e.target.value.slice(0, 9).replace(/[^\d.-]/g, "");
    e.target.value = filteredQuery > 0 ? filteredQuery : "";
    // eslint-disable-next-line
    this.props.getRowInfo(ref, row);
  };
  handleChangeQtyOrdered = (e, num) => {
    e.target.parentElement.children[1].value =
      parseInt(e.target.parentElement.children[1].value, 10) + num <= 0
        ? 1
        : parseInt(e.target.parentElement.children[1].value, 10) + num;
    if (isNaN(e.target.parentElement.children[1].value)) {
      e.target.parentElement.children[1].value = 1;
    }
  };
  onQtyOrderedBlur = (target, i, row) => {
    // eslint-disable-next-line
    target.value === "" ? (target.value = row.qtyOrdered) : null;
    this.props.getRowInfo(this["rowRef" + i].current, row);
  };
  handleScroll = event => {
    if (this.tableRef.current.getBoundingClientRect().top > 0) {
      // eslint-disable-next-line
      this.state.isHeaderFixed !== false
        ? (this.tableHeaderRef.current.classList = "table-row title-row")
        : null;
    } else {
      // eslint-disable-next-line
      this.state.isHeaderFixed !== true
        ? (this.tableHeaderRef.current.classList =
            "table-row title-row fixed-to-top")
        : null;
    }
  };

  renderTableRows = () => {
    var areUnsavedChanges =
      Object.keys(this.props.changes).length >= 1 ? true : false;
    return this.props.rows
      .map((row, i) => {
        this["rowRef" + i] = React.createRef();
        return (
          <div
            key={i}
            className={"table-row-wrapper"}
            style={
              (areUnsavedChanges &&
                this.props.changes[row.itemNumber] &&
                this.props.changes[row.itemNumber].cancelFlag === "C") ||
              row.cancelFlag === "C"
                ? { background: "rgba(200, 50, 0, 0.15)" }
                : null
            }
          >
            <input
              id={`rowRad2${i}`}
              className="rowInput"
              name="rowRad"
              type="radio"
            />
            <label
              htmlFor={`rowRad2${i}`}
              ref={this["rowRef" + i]}
              onClick={
                row.cancelFlag === "C" || this.props.readOnly
                  ? null
                  : e => this.props.getRowInfo(this["rowRef" + i].current, row)
              }
              className={`table-row`}
            >
              <label className="table-cell">
                <p className="table-text">
                  {row.cancelFlag !== "C" ? (
                    <Fragment>
                      <input
                        type="checkbox"
                        checked={
                          areUnsavedChanges &&
                          this.props.changes[row.itemNumber]
                            ? this.props.changes[row.itemNumber].cancelFlag ===
                              "Y"
                              ? true
                              : false
                            : row.cancelFlag === "C"
                            ? true
                            : false
                        }
                        onChange={e => {
                          return null;
                        }}
                      />
                      {this.props.readOnly ? (
                        ""
                      ) : (
                        <i className="material-icons check unchecked cancel">
                          cancel
                        </i>
                      )}
                      <i className="check checked cancel">Undo</i>
                    </Fragment>
                  ) : (
                    <Fragment>C-CANC</Fragment>
                  )}
                </p>
              </label>
              <div className="table-cell">
                <p className="table-text">{row.partNumber}</p>
              </div>
              <div className="table-cell">
                <p className="table-text">
                  {this.numberToCeroPadded(row.itemNumber)}
                </p>
              </div>
              <div className="table-cell" style={{ flex: "2" }}>
                <p className="table-text">{row.description}</p>
              </div>
              <label className="table-cell">
                <div className="table-text">
                  {row.cancelFlag !== "C" && !this.props.readOnly ? (
                    <Fragment>
                      <input
                        onChange={e => {
                          return null;
                        }}
                        type="checkbox"
                        // defaultChecked={row.fbuyFlag === "Y" ? true : false}
                        checked={
                          areUnsavedChanges &&
                          this.props.changes[row.itemNumber]
                            ? // eslint-disable-next-line
                              this.props.changes[row.itemNumber].fbuyFlag == "Y"
                              ? true
                              : false
                            : // eslint-disable-next-line
                            row.fbuyFlag == "Y"
                            ? true
                            : false
                        }
                      />
                      <div className="check-box bordered">
                        {areUnsavedChanges &&
                        this.props.changes[row.itemNumber] ? (
                          // eslint-disable-next-line
                          this.props.changes[row.itemNumber].fbuyFlag == "Y" ? (
                            <i className="material-icons">check</i>
                          ) : (
                            false
                          )
                        ) : // eslint-disable-next-line
                        row.fbuyFlag == "Y" ? (
                          <i className="material-icons">check</i>
                        ) : (
                          false
                        )}
                      </div>
                      <div
                        className="hotmod"
                        style={
                          this.props.changes[row.itemNumber] &&
                          this.props.changes[row.itemNumber].fbuyFlag !==
                            row.fbuyFlag
                            ? { visibility: "visible", opacity: 1 }
                            : { visibility: "hidden", opacity: 0 }
                        }
                      >
                        <HotModIndicator />
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div className="check-box">
                        {areUnsavedChanges &&
                        this.props.changes[row.itemNumber] ? (
                          // eslint-disable-next-line
                          this.props.changes[row.itemNumber].fbuyFlag == "Y" ? (
                            <i className="material-icons">check</i>
                          ) : (
                            false
                          )
                        ) : // eslint-disable-next-line
                        row.fbuyFlag == "Y" ? (
                          <i className="material-icons">check</i>
                        ) : (
                          false
                        )}
                      </div>
                    </Fragment>
                  )}
                </div>
              </label>
              <label className="table-cell">
                <div className="table-text">
                  {row.cancelFlag !== "C" && !this.props.readOnly ? (
                    <Fragment>
                      <input
                        type="checkbox"
                        // defaultChecked={row.fbuyFlag === "Y" ? true : false}
                        checked={
                          areUnsavedChanges &&
                          this.props.changes[row.itemNumber]
                            ? this.props.changes[row.itemNumber].availFlag ===
                              "Y"
                              ? true
                              : false
                            : row.availFlag === "Y"
                            ? true
                            : false
                        }
                        onChange={e => {
                          return null;
                        }}
                      />
                      <div className="check-box bordered">
                        {areUnsavedChanges &&
                        this.props.changes[row.itemNumber] ? (
                          // eslint-disable-next-line
                          this.props.changes[row.itemNumber].availFlag ==
                          "Y" ? (
                            <i className="material-icons">check</i>
                          ) : (
                            false
                          )
                        ) : // eslint-disable-next-line
                        row.availFlag == "Y" ? (
                          <i className="material-icons">check</i>
                        ) : (
                          false
                        )}
                      </div>
                      <div
                        className="hotmod"
                        style={
                          this.props.changes[row.itemNumber] &&
                          this.props.changes[row.itemNumber].availFlag !==
                            row.availFlag
                            ? { visibility: "visible", opacity: 1 }
                            : { visibility: "hidden", opacity: 0 }
                        }
                      >
                        <HotModIndicator />
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div className="check-box ">
                        {areUnsavedChanges &&
                        this.props.changes[row.itemNumber] ? (
                          // eslint-disable-next-line
                          this.props.changes[row.itemNumber].availFlag ==
                          "Y" ? (
                            <i className="material-icons">check</i>
                          ) : (
                            false
                          )
                        ) : // eslint-disable-next-line
                        row.availFlag == "Y" ? (
                          <i className="material-icons">check</i>
                        ) : (
                          false
                        )}
                      </div>
                    </Fragment>
                  )}
                </div>
              </label>
              <div className="table-cell with-hotmod">
                {row.cancelFlag !== "C" && !this.props.readOnly ? (
                  <Fragment>
                    <i
                      className="material-icons"
                      onClick={e => this.handleChangeQtyOrdered(e, -1)}
                    >
                      navigate_before
                    </i>

                    <input
                      className="table-text qty-input"
                      onKeyDown={e => this.onKeyPress(e)}
                      // value={row.qtyOrdered}
                      value={
                        areUnsavedChanges && this.props.changes[row.itemNumber]
                          ? this.props.changes[row.itemNumber].qtyOrdered
                          : row.qtyOrdered
                      }
                      onBlur={e => this.onQtyOrderedBlur(e.target, i, row)}
                      onChange={e =>
                        this.changeQty(e, this["rowRef" + i].current, row)
                      }
                    />
                    <i
                      className="material-icons"
                      onClick={e => this.handleChangeQtyOrdered(e, 1)}
                    >
                      navigate_next
                    </i>
                    <div
                      className={`hotmod ${
                        this.props.changes[row.itemNumber] &&
                        this.props.changes[row.itemNumber].qtyOrdered !==
                          row.qtyOrdered
                          ? "on"
                          : "off"
                      }`}
                    >
                      <HotModIndicator />
                    </div>
                  </Fragment>
                ) : (
                  <p className="table-text">{this.formatNumber(row.qtyOrdered)}</p>
                )}
              </div>
              <div className="table-cell">
                <p className="table-text">{this.formatNumber(row.qtyReceived)}</p>
              </div>
              <div className="table-cell select with-hotmod">
                {row.cancelFlag !== "C" && !this.props.readOnly ? (
                  <Fragment>
                    <select
                      name="categories"
                      // defaultValue={row.invCategory}
                      value={
                        this.state.cat
                          ? this.state.cat[row.itemNumber]
                          : row.invCategory
                        // areUnsavedChanges && this.props.changes[row.itemNumber]
                        //   ? this.props.changes[row.itemNumber].invCategory
                        //   : row.invCategory
                      }
                      onChange={e =>
                        this.setState({
                          cat: { [row.itemNumber]: e.target.value }
                        })
                      }
                    >
                      {this.renderCategories()}
                    </select>
                    <div
                      className={`hotmod ${
                        this.props.changes[row.itemNumber] &&
                        this.props.changes[row.itemNumber].invCategory !==
                          row.invCategory
                          ? "on"
                          : "off"
                      }`}
                    >
                      <HotModIndicator />
                    </div>
                  </Fragment>
                ) : (
                  <p className="table-text">
                    {this.categories[row.invCategory]}
                  </p>
                )}
              </div>
              <div className="table-cell">
                <div className="table-cell-div-wrapper">
                  <p className="table-text">$</p>
                  <p className="table-text costNumber">
                    {this.numberWithCommas(row.unitCost)}
                  </p>
                </div>
              </div>
            </label>
          </div>
        );
      })
      .slice(
        (this.props.currentPage - 1) * this.props.numberOfRows,
        this.props.currentPage * this.props.numberOfRows
      );
  };
  numberWithCommas = x => {
    var parts = x
      .toFixed(2)
      .toString()
      .split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  render() {
    return (
      <div ref={this.tableRef} className="table-container">
        <div ref={this.tableHeaderRef} className="table-row title-row">
          {this.renderTableHeader()}
        </div>
        <div>{this.renderTableRows()}</div>
      </div>
    );
  }
}

export default PODTable;
